import { ConsumptionInterfaceState, initialConsumptionState } from '../state/consumption.state';
import { ConsumptionActions, EConsumptionActions } from '../actions/consumption.actions';

export function consumptionReducer(state: ConsumptionInterfaceState = initialConsumptionState, action: ConsumptionActions): ConsumptionInterfaceState {
  switch (action.type) {
    case EConsumptionActions.GetConsumptionSuccess: {
      return { ...state, consumption: action.payload };
    }

    default:
      return state;
  }
};
